import { useMutation, useQueryClient } from 'react-query'
import { BigNumber } from 'ethers'
import { useWallet } from '~/lib/useWallet'
import { getVotingEscrowContract } from '~/contracts/getVotingEscrowContract'
import { sisTokenKeys } from '~/lib/queryKeys'
import { useVESISParams } from '~/hooks/useVESISParams'

export function useIncreaseAmount(value?: BigNumber) {
	const { config } = useVESISParams()

	const { web3, account } = useWallet()

	const queryClient = useQueryClient()

	return useMutation(
		async () => {
			if (!value) {
				return
			}

			const contract = getVotingEscrowContract(config, web3).connect(
				web3.getSigner(account)
			)

			const tx = await contract.increase_amount(value.toString())

			await tx.wait()
		},
		{
			onSuccess() {
				queryClient.resetQueries(
					sisTokenKeys.balance(config.chain.id, account)
				)
				queryClient.resetQueries(['sis-lock'])
			},
		}
	)
}
